var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{ref:"editor",attrs:{"id":_vm.editorId,"outlined":_vm.outlined,"editor-url":_vm.editorUrl,"config":_vm.editorConfig,"value":_vm.textContent,"tag-name":"textarea"},on:{"input":function($event){return _vm.setContent($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }